<template>
  <div id="publishing-special-issue-add">
    <div class="ipub-h1 mar-b-20">{{this.params.id?'Topics Details':'Add Topics'}}</div>
    <ipub-form ref="topic-add-form"
               :model="params"
               autocomplete="off"
               :rules="rules">
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="journalIdList"
                          label="Journal">
            <ipub-select v-model="params.journalIdList"
                         placeholder="Select Journal"
                         mode="multiple"
                         :options="journalList" />
            <!-- <ipub-select v-model="params.journalId"
                         mode="multiple"
                         placeholder="Select Journal"
                         :disabled="$route.path.includes('/editorial-office')"
                         @change="(e)=>{onJournalChange(e, true)}">
              <ipub-select-option v-for="(item,index) in journalList"
                                  v-show="item.name!='EJGO'"
                                  :key="item.id"
                                  :value="item.id">
                {{item.fullName}}
              </ipub-select-option>
            </ipub-select> -->
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="code"
                          label="Website Abbreviation">
            <ipub-input placeholder="Enter Abbreviation to create unique URL"
                        v-model.trim="params.code" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="startTime"
                          label="Start Date">
            <ipub-date-picker placeholder="Select start time"
                              v-model="params.startTime" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="abstractTime"
                          label="Abstract Submission Deadline">
            <ipub-date-picker placeholder="Select abstract submission deadline"
                              v-model="params.abstractTime" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="manuscriptTime"
                          label="Manuscript Submission Deadline">
            <ipub-date-picker placeholder="Select manuscript submission deadline"
                              v-model="params.manuscriptTime" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-form-item prop="title"
                      label="Topic Title">
        <ipub-editor :height="150"
                     placeholder="Enter special issue title here…"
                     v-model="params.title" />
      </ipub-form-item>
      <ipub-form-item prop="summary"
                      label="Topic Information">
        <ipub-editor :height="300"
                     v-model="params.summary" />
      </ipub-form-item>
      <ipub-form-item prop="content"
                      label="Custom Content">
        <ipub-editor :height="300"
                     v-model="params.content" />
      </ipub-form-item>

      <ipub-form-item label="Keywords"
                      prop="keyword">
        <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                    tag
                    v-model="params.keywords" />
      </ipub-form-item>

      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="flyer">
            <div class="ipub-p2 fw-bd mar-b-10 relative"
                 slot="label">
              Topic Flyer
              <ipub-tooltip placement="right"
                            type="dark"
                            class="mar-l-10">
                <div slot="title">PDF</div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-upload-input :file="params"
                               _name="flyerName"
                               _path="flyer"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('flyer')"
                               @change="(e)=>{handleUpload('flyer', e)}" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>

    </ipub-form>
    <div class="guestEditorSearch">
      <div class="ipub-p2 fw-bd mar-b-10 border-bottom">Topic Editor(s)
        <font class="link-color mar-l-12 ipub-p2 ipub-c-p"
              @click="addTopicEditor">
          <ipub-icon type="iconAdd"></ipub-icon>
          Add New Topic Editor
        </font>
      </div>
      <!-- <div class="flex mar-b-30">
        <ipub-input v-model="topicEditorEmail"
                    style="width:300px;margin-right:20px"
                    placeholder="Search or create by Email" />
        <ipub-button type="primary"
                     class="ipub-p1 line-h-40"
                     @click="addTopicEditor"
                     icon="iconAdd"></ipub-button>
      </div> -->
      <template v-if="params.editorList && params.editorList.length>0">
        <div v-for="(item,key) in idetifyEditorObj"
             :key="key">
          <div class="ipub-p2 fw-bd">{{topicEditorObj[key]}}(s)</div>
          <ipub-table :columns="guestEditorColumns"
                      :pagination="false"
                      draggable
                      @drag="(val)=>{setSort(val,key)}"
                      fixed
                      :dataSource="idetifyEditorObj[key]">
            <!-- :dataSource="params.editorList -->
            <template v-slot:name="{record}">
              <ipub-tooltip style="width:100%"
                            placement="bottomLeft"
                            omis="omis"
                            :label="`${record.firstName} ${record.lastName}`" />
            </template>
            <template v-slot:link="{text, record}">
              <a v-if="text"
                 @click="download(`${domain}/${text}`, text)"
                 class="link-color omis"
                 target="_blank"
                 style="display:inline-block;width:100%">{{record.cvName}}</a>
              <!-- :href="`${domain}/${text}`" -->
              <template v-else>- -</template>
            </template>
            <template v-slot:actions="{ record, index }">
              <!-- {{text}} -->
              <ipub-tooltip class="border-right">
                <div slot="title">Edit</div>
                <ipub-icon type="iconEdit"
                           @click="editTopicEditor(key,record)" />
              </ipub-tooltip>
              <ipub-tooltip>
                <div slot="title">Delete</div>
                <ipub-icon type="iconDelete"
                           @click="delTopicEditor(key,index)" />
              </ipub-tooltip>
            </template>
          </ipub-table>
        </div>
      </template>
      <template v-else>
        <div class="ipub-p2 mar-b-20">Please add topic editor.</div>
      </template>
    </div>
    <div class="btns ipub-p1 line-h-40">
      <ipub-button type="primary"
                   plain
                   style="width:150px"
                   @click="$router.back(-1)">Cancel</ipub-button>
      <ipub-button type="primary"
                   v-if="user.codeList&&user.codeList.includes('WEBSITE.TOPICS.ADD.SAVE')"
                   style="width:150px"
                   @click="save()">Save</ipub-button>
      <template v-if="!params.id&&user.codeList&&user.codeList.includes('WEBSITE.TOPICS.ADD.PUBLISH')">
        <ipub-button type="primary"
                     style="width:150px"
                     @click="save('Publish')">Publish</ipub-button>
      </template>
    </div>
    <Add ref="topic-editor-add"
         :isVisable="isVisable"
         :inputData="inputData"
         :editors="params.editorList"
         @confirm="confirm"
         @cancel="cancel" />
    <AddPlannedPaper ref="planned-paper-add"
                     :isVisable="isVisablePlannedPaper"
                     :inputData="inputData"
                     @confirm="confirmPlannedPaper"
                     @cancel="cancel" />
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="APPROVAL_OF_SPECIAL_ISSUE_APPLICATION"
               @cancel="cancel" />
    <CreatePNG :isVisable="isVisablePDF"
               :inputData="inputData"
               :type="pdfType"
               :journalId="params.journalId"
               @confirm="cancel"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
